"use client";

import { useEffect, useState } from "react";

/**
 * Keeps a panel mounted for a short time after `open=false`, so CSS can play
 * the closing animation before React removes the element from the DOM.
 */
export function useExitAnimation(open: boolean, durationMs = 90) {
  const [mounted, setMounted] = useState(open);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (open) {
      setMounted(true);
      setClosing(false);
      return;
    }

    if (!mounted) return;
    setClosing(true);
    const timer = window.setTimeout(() => {
      setMounted(false);
      setClosing(false);
    }, durationMs);
    return () => window.clearTimeout(timer);
  }, [durationMs, mounted, open]);

  return {
    mounted,
    closing,
    state: closing ? "closing" : "open",
  } as const;
}
